import { render } from "./AuthenticationCardLogo.vue?vue&type=template&id=606ac335"
import script from "./AuthenticationCardLogo.vue?vue&type=script&lang=js"
export * from "./AuthenticationCardLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/WD 1/Development/Laravel/pessoalform_crm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__